import type { Category } from '@/lib/calculators'
import { CATEGORIES } from '@/lib/calculators'

interface Props {
  active: Category
  onChange: (c: Category) => void
}

function CategoryRail({ active, onChange }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {CATEGORIES.map(cat => (
        <button
          key={cat.id}
          onClick={() => onChange(cat.id)}
          className={`px-4 py-2 rounded-full text-xs md:text-sm font-medium border transition-all ${
            active === cat.id
              ? 'border-emerald-400/60 bg-emerald-400/10 text-emerald-200 shadow-md shadow-emerald-500/10'
              : 'border-[var(--line)] bg-white/[0.02] text-slate-300 hover:border-[var(--line-strong)] hover:text-white'
          }`}
        >
          {cat.label}
        </button>
      ))}
    </div>
  )
}

export default CategoryRail
